export interface WicketWalletPaginatedResponse<T> {
  data: T[];
  has_more: boolean;
  last_evaluated_key: string;
}
